// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__QtXRk","rightAdornment":"Header_rightAdornment__2Fi5e"};